import { ThemePalette, generateColorScale } from '../utils/color-utils';

export const pinkPalette: ThemePalette = {
  name: 'pink',
  primary: {
    50: '#FDF2F8',
    100: '#FCE7F3',
    200: '#FBCFE8',
    300: '#F9A8D4',
    400: '#F472B6',
    500: '#EC4899',
    600: '#DB2777',
    700: '#BE185D',
    800: '#9D174D',
    900: '#831843',
    950: '#500724',
  },
  secondary: {
    50: '#FFF1F2',
    100: '#FFE4E6',
    200: '#FECDD3',
    300: '#FDA4AF',
    400: '#FB7185',
    500: '#F43F5E',
    600: '#E11D48',
    700: '#BE123C',
    800: '#9F1239',
    900: '#881337',
    950: '#4C0519',
  },
};

export const orangePalette: ThemePalette = {
  name: 'orange',
  primary: {
    50: '#FFF5F0',
    100: '#FFE8DB',
    200: '#FFD1B8',
    300: '#FFBA94',
    400: '#FFA371',
    500: '#FF6500',
    600: '#EA580C',
    700: '#C2410C',
    800: '#9A3412',
    900: '#7C2D12',
    950: '#431407',
  },
  secondary: {
    50: '#FEF3C7',
    100: '#FDE68A',
    200: '#FCD34D',
    300: '#FBBF24',
    400: '#F59E0B',
    500: '#D97706',
    600: '#B45309',
    700: '#92400E',
    800: '#78350F',
    900: '#451A03',
    950: '#1C0A00',
  },
};

export const bluePalette: ThemePalette = {
  name: 'blue',
  primary: generateColorScale('#3B82F6'),
  secondary: generateColorScale('#1D4ED8'),
};

export const greenPalette: ThemePalette = {
  name: 'green',
  primary: generateColorScale('#10B981'),
  secondary: generateColorScale('#059669'),
};

export const purplePalette: ThemePalette = {
  name: 'purple',
  primary: generateColorScale('#8B5CF6'),
  secondary: generateColorScale('#7C3AED'),
};

export const tealPalette: ThemePalette = {
  name: 'teal',
  primary: generateColorScale('#14B8A6'),
  secondary: generateColorScale('#0D9488'),
};

export const themes: Record<string, ThemePalette> = {
  default: pinkPalette,
  pink: pinkPalette,
  orange: orangePalette,
  blue: bluePalette,
  green: greenPalette,
  purple: purplePalette,
  teal: tealPalette,
};

export const defaultTheme = pinkPalette;
